import React from 'react';
import niunamas from './images/niunamas.png';


const SoporteLegal = ({ title, content }) => {
  return (
    <div id="apoyopsicologico" className="bg-black text-center text-lg font-sans py-10 px-4">
        <div className='text-white font-bold'>
          <h2 id="quienessomos" className="text-[#9775bb] text-3xl font-bold mb-4" >¿Quiénes Somos?</h2>
            <p>
                Somos una organización comprometida con brindar apoyo a mujeres, niñas y adolescentes víctimas de violencia. Nuestra misión es educar, prevenir y acompañar en el proceso de recuperación.
            </p>
            <div className="mt-6">
                <h3 className="text-3xl font-bold text-[#9775bb]" >Aliadas y patrocinadoras</h3>
                <p>Empresas y organizaciones que nos apoyan en nuestra misión.</p>
            </div>
            <div className='text-md pt-6 font-bold flex text-center justify-center gap-10'>
            <h3 className='' >Diana Serrano <br /> Licenciada en Psicología</h3>
            <h3 className='text-white'>Gabriela Sarabia <br /> Licenciada en Derecho</h3>
            </div>
            
          </div>
    </div>
  );
};

export default SoporteLegal;
